import { t } from 'i18next';

import utils = egr.wcf.utils;

export const lcidMap: {[key: string]: string} = {
    de: '407',
    en: '409', /* also available: many! */
    es: 'C0A', /* also available: many! */
    fr: '40C', /* also available: fr_BE, fr_CA, fr_FR, fr_LU, fr_CH */
    it: '410', /* also available: it_CH */
    nl: '413', /* also available: nl_BE */
    pl: '407',
    pt: '816', /* also available: nl_BR (Brazil) */
    ro: '418',
    tr: '41F',
};

export function getPdfTranslations(currency?: string): {[key: string]: string} {
    if (utils.string.isNullOrEmpty(currency)) {
        return {
            'Single Price': t('Single Price'),
            'Total Price': t('Total Price'),
            'Price (excl. Tax)': t('Price (excl. Tax)'),
            'Total Price (excl. Tax)': t('Total Price (excl. Tax)'),
            'Pos.': t('Pos.'),
            'Article Image': t('Article Image'),
            Description: t('Description'),
            Quantity: t('Quantity'),
            'Product Sheet': t('Product Sheet'),
        };
    }
    return {
        'Single Price': t('SP in {{currency}}', {currency, context: 'SP = shortform of Single Price'}),
        'Total Price': t('TP in {{currency}}', {currency, context: 'TP = shortform of Total Price'}),
        'Price (excl. Tax)': t('Price in {{currency}} (excl. Tax)', {currency}),
        'Total Price (excl. Tax)': t('Total Price in {{currency}} (excl. Tax)', {currency}),
        'Pos.': t('Pos.'),
        'Article Image': t('Article Image'),
        Description: t('Description'),
        Quantity: t('Quantity'),
        'Product Sheet': t('Product Sheet'),
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/submodules/articlelist-export/Utils.ts